import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getCheckUploadStatus = async (
    token,
    jobId
) => {
    const endpoint = `/api/v1/admin/reports/import_status?job_id=${jobId}`;
    try {
        const response = await fetch(`${BASE_URL}${endpoint}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Token ${token}`,
            },
        });

        const data = await response.json();
        return data;

    } catch (error) {
        toast.error(error.message || "something went wrong");
    }
};
